import React from "react"
import { format } from "date-fns"
import formatTweet from "./format-tweet"
import TwitterLogo from "./components/twitter-logo"
import VerifiedBadge from "./components/verified-badge"
import SlateNode from "../slate-node"

const systemFonts =
  "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif !important"

const Tweet = ({ children, attributes, node }) => {
  return (
    <SlateNode
      {...attributes}
      as="table"
      node={node}
      style={{
        border: "1px",
        borderStyle: "solid",
        borderRadius: "10px",
        borderColor: "rgb(204, 214, 221)",
        padding: "14px 14px 6px 14px",
        width: "100%",
        maxWidth: "375px",
        backgroundColor: "white",
        borderCollapse: "separate",
        fontWeight: "300",
        color: "black",
        fontFamily: systemFonts
      }}
    >
      <tbody>
        <tr>
          <td>{children}</td>
        </tr>
      </tbody>
    </SlateNode>
  )
}

const Header = ({ user }) => {
  return (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        padding: "0"
      }}
    >
      <tbody>
        <tr>
          <td style={{ width: "50px" }}>
            <div
              style={{
                marginRight: "8px",
                height: "46px",
                width: "46px"
              }}
            >
              <img
                style={{
                  borderRadius: "50%",
                  border: "1px solid",
                  borderColor: "lightgray"
                }}
                src={user.profile_image_url}
                alt="twitter profile avatar"
              />
            </div>
          </td>
          <td>
            <div
              style={{
                color: "black",
                fontWeight: 700,
                fontSize: "15px",
                textAlign: "left",
                paddingBottom: "0px",
                width: "100%",
                fontFamily: systemFonts
              }}
            >
              {user.name}
              {user.verified === true ? <VerifiedBadge /> : null}
              <TwitterLogo />
            </div>
            <div
              style={{
                color: "rgb(101,119,134)",
                fontSize: "14px",
                textAlign: "left",
                fontWeight: 400,
                fontFamily: systemFonts
              }}
            >
              @{user.username}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

const Body = ({ tweet, attributes }) => {
  const TweetText = { __html: formatTweet(tweet.text, tweet.entities) }
  const quotedTweet = tweet.tweets?.[0]
  return (
    <div style={{ paddingTop: "8px" }} {...attributes}>
      <a
        onClick={event => event.preventDefault()}
        style={{ textDecoration: "none", zIndex: "3" }}
        href={`https://twitter.com/${tweet.users[0].username}/status/${tweet.id}`}
      >
        {tweet.text && (
          <div
            dangerouslySetInnerHTML={TweetText}
            style={{
              color: "rgb(20, 23, 26)",
              whiteSpace: "pre-wrap",
              textAlign: "left",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "1.3125",
              fontFamily: systemFonts
            }}
          />
        )}
        {tweet.media ? <Media media={tweet.media} /> : null}
        {!tweet.media && tweet.entities?.urls && !tweet.tweets ? (
          <Link
            title={tweet.entities.urls[0].title}
            imageUrl={tweet.entities.urls[0].images?.[0].url}
            description={tweet.entities.urls[0].description}
            unwoundUrl={tweet.entities.urls[0].display_url.split("/")[0]}
          />
        ) : null}
        {quotedTweet ? (
          <QuoteTweet tweet={quotedTweet} users={tweet.users} />
        ) : null}
      </a>
    </div>
  )
}

const Media = ({ media }) => {
  if (!media.length) return null
  return (
    <table style={{ width: "100%", marginTop: "5px" }}>
      <tbody>
        {media.length == 2 ? (
          <tr>
            {media.map(medium => {
              // videos/gif || images
              const src = medium.preview_image_url || medium.url
              return (
                <td key={medium.media_key} style={{ width: "50%" }}>
                  <img
                    width="375" // only applys to outlook
                    style={{
                      width: "100%",
                      border: "1px solid",
                      borderRadius: "10px",
                      borderColor: "rgb(204, 214, 221)"
                    }}
                    src={src}
                    alt={medium.type === "image" ? "Image" : "Video or Gif"}
                  />
                </td>
              )
            })}
          </tr>
        ) : (
          media.map(medium => {
            // videos/gif || images
            const src = medium.preview_image_url || medium.url
            return (
              <tr key={medium.media_key}>
                <td>
                  <img
                    width="375" // only applys to outlook
                    style={{
                      width: "100%",
                      border: "1px solid",
                      borderRadius: "10px",
                      borderColor: "rgb(204, 214, 221)"
                    }}
                    src={src}
                    alt={medium.type === "image" ? "Image" : "Video or Gif"}
                  />
                </td>
              </tr>
            )
          })
        )}
      </tbody>
    </table>
  )
}

const Link = ({ title, imageUrl, description, unwoundUrl }) => {
  const ellipsis = (string, count) => {
    if (string && string.length <= count) {
      return string
    }
    return `${string.slice(0, count)}...`
  }

  return (
    <>
      {title && description && (
        <table
          style={{
            border: "1px",
            borderStyle: "solid",
            borderRadius: "10px",
            borderColor: "#D3D3D3",
            overflow: "hidden",
            borderCollapse: "separate",
            padding: "0",
            marginTop: "5px",
            webkitBorderVerticalSpacing: "0px",
            webkitBorderHorizontalSpacing: "0px"
          }}
        >
          <tbody
            style={{
              webkitBorderVerticalSpacing: "0px",
              webkitBorderHorizontalSpacing: "0px"
            }}
          >
            <tr style={{ padding: "0" }}>
              <td style={{ padding: "0" }}>
                {imageUrl && (
                  <div
                    style={{
                      width: "145px",
                      height: "145px"
                    }}
                  >
                    <img
                      style={{
                        objectFit: "cover",
                        objectPosition: "center",
                        height: "100%",
                        width: "100%",
                        borderTopLeftRadius: "10px",
                        borderBottomLeftRadius: "10px"
                      }}
                      src={imageUrl}
                      alt="link visual"
                    />
                  </div>
                )}
              </td>
              <td>
                <div
                  style={{
                    paddingRight: "8px",
                    paddingLeft: "8px",
                    color: "black",
                    fontSize: "16px",
                    fontWeight: "500",
                    textAlign: "left",
                    marginTop: "10px",
                    fontFamily: systemFonts
                  }}
                >
                  {ellipsis(title, 48)}
                </div>
                <div
                  style={{
                    color: "grey",
                    fontSize: "13px",
                    paddingTop: "4px",
                    paddingLeft: "8px",
                    textAlign: "left",
                    fontFamily: systemFonts
                  }}
                >
                  {ellipsis(description, 100)}
                </div>
                <div
                  style={{
                    paddingTop: "10px",
                    paddingLeft: "8px",
                    wordBreak: "break-all",
                    fontSize: "12px",
                    color: "grey",
                    textAlign: "left",
                    fontFamily: systemFonts
                  }}
                >
                  {unwoundUrl}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </>
  )
}

const QuoteTweet = ({ tweet, users }) => {
  const author = users.find(user => user.id === tweet.author_id)
  const TweetText = { __html: formatTweet(tweet.text, tweet.entities) }
  return (
    <div
      style={{
        border: "1px",
        borderStyle: "solid",
        borderRadius: "10px",
        borderColor: "rgb(204, 214, 221)",
        padding: "8px",
        marginTop: "8px"
      }}
    >
      <table>
        <tbody>
          <tr>
            <td>
              <div style={{ paddingRight: "5px" }}>
                <img
                  width={20}
                  style={{ borderRadius: "50%" }}
                  src={author.profile_image_url}
                  alt="twitter profile avatar"
                />
              </div>
            </td>
            <td>
              <div
                style={{
                  paddingTop: "4px",
                  color: "rgb(20, 23, 26)",
                  fontWeight: 700,
                  fontSize: "15px",
                  marginRight: "5px",
                  fontFamily: systemFonts
                }}
              >
                {author.name}
                {author.verified === true ? <VerifiedBadge /> : null}
              </div>
            </td>
            <td>
              <div
                style={{
                  color: "rgb(101, 119, 134)",
                  fontSize: "15px",
                  paddingTop: "4px",
                  fontWeight: 400,
                  fontFamily: systemFonts
                }}
              >
                @{author.username}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        dangerouslySetInnerHTML={TweetText}
        style={{
          paddingTop: "5px",
          textAlign: "left",
          fontSize: "15px",
          fontWeight: 400,
          color: "rgb(20, 23, 26)",
          lineHeight: "1.3125",
          fontFamily: systemFonts
        }}
      ></div>
    </div>
  )
}

const Footer = ({ retweetCount, likeCount, createdAt }) => {
  return (
    <>
      <div
        style={{
          color: "rgb(101,119,134)",
          padding: "4px 0",
          paddingTop: "4px",
          textAlign: "left",
          fontSize: "14px",
          fontWeight: 400,
          fontFamily: systemFonts
        }}
      >
        {createdAt}
      </div>
      <div
        style={{
          borderTop: "1px solid rgb(204, 214, 221)",
          marginTop: "2px",
          paddingBottom: "6px",
          fontFamily: systemFonts
        }}
      />
      <table style={{ width: "auto!important" }}>
        <tbody>
          <tr>
            <td>
              <div
                style={{
                  color: "rgb(20, 23, 26)",
                  fontWeight: "600",
                  paddingRight: "4px",
                  fontSize: "14px",
                  fontFamily: systemFonts
                }}
              >
                {retweetCount}
              </div>
            </td>
            <td>
              <div
                style={{
                  color: "rgb(101, 119, 134)",
                  paddingRight: "8px",
                  fontWeight: "400",
                  textAlign: "left",
                  fontSize: "14px",
                  fontFamily: systemFonts
                }}
              >
                Retweets
              </div>
            </td>
            <td>
              <div
                style={{
                  color: "rgb(20, 23, 26)",
                  fontWeight: "600",
                  paddingRight: "4px",
                  fontSize: "14px",
                  fontFamily: systemFonts
                }}
              >
                {likeCount}
              </div>
            </td>
            <td>
              <div
                style={{
                  color: "rgb(101, 119, 134)",
                  fontWeight: "400",
                  fontSize: "14px",
                  fontFamily: systemFonts
                }}
              >
                Likes
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default function TweetEmbed({ data, attributes, node }) {
  const { tweet } = data
  if (!tweet) return null
  const tweetDate = format(new Date(tweet.created_at), "MMMM do yyyy")
  return (
    <Tweet
      node={node}
      userName={tweet.users[0].username}
      id={tweet.id}
      attributes={attributes}
    >
      <Header user={tweet.users[0]} />
      <Body tweet={tweet} />
      <Footer
        likeCount={tweet.public_metrics.like_count.toLocaleString()}
        retweetCount={tweet.public_metrics.retweet_count.toLocaleString()}
        createdAt={tweetDate}
      />
    </Tweet>
  )
}
